import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer,
} from 'antd';
import { EditOutlined, PlusCircleFilled, CloseOutlined } from '@ant-design/icons';
import UserActions from '@Actions/userActions';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import H3Image from '@Uilib/h3Image';
import { v4 as uuidv4 } from 'uuid';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import UomActions from '@Actions/uomActions';
import './style.scss';

const Uom = ({
  user, updateUom, updateUomLoading, getUserProfile,
}) => {
  const [showUomGroupModal, setShowUomGroupModal] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedUomGroup, setSelectedUomGroup] = useState({});
  const [uomList, setUomList] = useState([]);
  // const [excludeUomIds, setExcludeUomIds] = useState([]);

  useEffect(() => {
    if (selectedUomGroup) {
      setUomList(selectedUomGroup?.uoms?.map((item) => ({ ...item, key: uuidv4() })));
    }
  }, [selectedUomGroup]);

  // useEffect(() => {
  //   setExcludeUomIds(uomList?.map((item) => item.uom_id));
  // }, [uomList]);

  const handleDelete = (key) => {
    const copyData = uomList.filter((item) => item.key !== key);
    setUomList(copyData);
  };

  const uomListColumns = [
    {
      title: 'UOM GROUP',
      width: '120px',
      render: (text, record) => (
        <Fragment>
          {record?.group_name || '-'}
        </Fragment>
      ),
    },
    {
      title: 'UOM(s)',
      render: (text, record) => (
        <div className="uoms__table-uqc-wrapper">
          {
            record?.uoms?.map((uom) => (
              <H3Text text={`${uom?.uom_name?.toProperCase()} (${uom?.uqc})`} className={`uoms__table-uqc ${uom?.is_base_uom ? 'uoms__table-uqc-base' : ''}`} />
            ))
          }
        </div>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            className="roundIconButton"
            onClick={() => {
              setSelectedUomGroup(record);
              setShowUomGroupModal(true);
            }}
          >
            <EditOutlined />
          </div>
        </div>
      ),
    },
  ];

  const uomGroupColumns = [
    {
      title: 'UOM NAME',
      width: '200px',
      render: (text, record) => (
        <Fragment>
          {record?.is_editable ? (
            <H3FormInput
              type="text"
              inputClassName={(formSubmitted && !record?.uom_name) ? 'orgFormInputError' : 'orgFormInput'}
              placeholder=""
              onChange={(event) => {
                const copyData = JSON.parse(JSON.stringify(uomList));
                const updatedCopyData = copyData.map((item) => {
                  if (item.key === record.key) {
                    return {
                      key: item?.key,
                      uom_name: event.target.value,
                      is_base_uom: false,
                      group_id: selectedUomGroup?.group_id,
                      is_editable: true,
                      uqc: '',
                    };
                  }
                  return item;
                });
                setUomList(updatedCopyData);
              }}
              value={record?.uom_name}
              maxlength="50"
              disabled={updateUomLoading}
            />
          ) : (
            <div style={{ display: 'flex' }}>
              {record?.uom_name || '-'}
              {record?.is_base_uom && (
                <span style={{
                  backgroundColor: '#2d7cf7', color: 'white', marginLeft: '9px', fontSize: '10px', padding: '1px 5px', borderRadius: '2px',
                }}
                >
                  Default
                </span>
              )}
            </div>
          )}
        </Fragment>
      ),
    },
    {
      title: 'UQC CODE',
      render: (text, record) => (
        <Fragment>
          {record?.is_editable ? (
            <H3FormInput
              name=""
              type="text"
              labelClassName="orgFormLabel"
              inputClassName={(formSubmitted && !record?.uqc) ? 'orgFormInputError' : 'orgFormInput'}
              placeholder=""
              // onWheel={(event) => event.target.blur()}
              onChange={(event) => {
                const uomListCopy = JSON.parse(JSON.stringify(uomList));
                for (let i = 0; i < uomListCopy?.length; i++) {
                  if (uomListCopy[i]?.key === record?.key) {
                    uomListCopy[i].uqc = event.target.value;
                    break;
                  }
                }
                setUomList(uomListCopy);
              }}
              value={record.uqc}
              maxlength="50"
              disabled={!record?.is_editable}
            />
          ) : (
            <div>
              {record?.uqc || '-'}
            </div>
          )}
        </Fragment>
      ),
    },
    {
      title: 'RATIO',
      render: (text, record) => (
        <Fragment>
          {record?.is_editable ? (
            <H3FormInput
              name="hsn"
              type="number"
              labelClassName="orgFormLabel"
              inputClassName={(formSubmitted && !record?.ratio) ? 'orgFormInputError' : 'orgFormInput'}
              placeholder=""
              onWheel={(event) => event.target.blur()}
              onChange={(event) => {
                const uomListCopy = JSON.parse(JSON.stringify(uomList));
                for (let i = 0; i < uomListCopy?.length; i++) {
                  if (uomListCopy[i]?.key === record?.key) {
                    uomListCopy[i].ratio = parseFloat(event.target.value);
                    break;
                  }
                }
                setUomList(uomListCopy);
              }}
              value={record.ratio}
              maxlength="50"
              disabled={!record?.is_editable}
            />
          ) : (
            <div>
              {record?.ratio || '-'}
            </div>
          )}
        </Fragment>
      ),
    },
    {
      title: '',
      render: (text, record) => (
        <Fragment>
          {record.is_editable && !record?.uom_id && (
            <div className="uom__delete-line-button" onClick={() => handleDelete(record.key)}>
              <CloseOutlined />
            </div>
          )}
        </Fragment>
      ),
      width: '40px',
      fixed: 'right',
    },
  ];

  /**
     *
     */
  const addNewRow = () => {
    const data = uomList;
    const copyData = JSON.parse(JSON.stringify(data || []));
    copyData.push({
      key: uuidv4(),
      uom_name: '',
      ratio: '',
      uqc: '',
      is_editable: true,
    });
    setUomList(copyData);
  };

  const isDataValid = () => {
    let isValid = true;
    const data = uomList;
    for (let i = 0; i < data?.length; i++) {
      if (!data[i]?.uom_name || !data[i]?.uqc || !data[i]?.ratio) {
        isValid = false;
      }
    }

    return isValid;
  };

  const updateUomForm = () => {
    setFormSubmitted(true);
    if (isDataValid()) {
      const payload = uomList;
      updateUom(payload, () => {
        setShowUomGroupModal(false);
        getUserProfile();
      });
    }
  };

  const uomGroups = Object.values(user?.tenant_info?.uom_groups_master);

  return (
    <Fragment>
      <div className="uoms__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-18">
            <div className="uoms__table__wrapper">
              <div className="uoms__table__data hide__in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {`${uomGroups?.length || '0'} UOM Groups`}
                    </div>
                  )}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={uomListColumns}
                  dataSource={uomGroups || []}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showUomGroupModal}
        width="480px"
        mask
        onClose={() => {
          setShowUomGroupModal(false);
          setFormSubmitted(false);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '435px' }}>
            <H3Text text={`UOM Group - ${selectedUomGroup?.group_name}`} className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowUomGroupModal(false);
                setFormSubmitted(false);
              }}
            />
          </div>
        </div>
        <div className="uoms__table__wrapper">
          <div className="uoms__table__data hide__in-mobile">
            <Table
              showHeader
              size="small"
              scroll="scroll"
              columns={uomGroupColumns}
              dataSource={uomList || []}
              pagination={false}
            />
            <div className="new-row-button" style={{ marginLeft: '10px', marginBottom: '35px' }} onClick={() => addNewRow()}>
              <span className="new-row-button__icon"><PlusCircleFilled /></span>
              <div>Add UOM</div>
            </div>
          </div>
        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Update UOM"
              onClick={() => updateUomForm()}
              isLoading={updateUomLoading}
              disabled={updateUomLoading}
              style={{
                width: '200px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, UomReducers,
}) => ({
  user: UserReducers.user,
  updateUomLoading: UomReducers.updateUomLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),
  updateUom: (payload, callback) => dispatch(UomActions.updateUom(payload, callback)),
});

Uom.propTypes = {
  user: PropTypes.any,
  getUserProfile: PropTypes.func,
  updateUomLoading: PropTypes.bool,
  updateUom: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Uom));
